// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1HgJ6","actions":"GroupTable_actions__25qqU","deleteModalFooter":"GroupTable_deleteModalFooter__SQUtn"};